export default {
	1: 'bg-secondary text-white', // Draft
	2: 'bg-warning text-dar', // Submitted -- default
	3: 'bg-success text-white', // Approved
	4: 'bg-danger text-white', // Rejected
	5: 'bg-danger text-white', // Invalid
	6: 'bg-light text-dark', // Archived
	7: 'bg-success text-white', // Valid
};
